import api from "./Api";

class ModelosCTeService {
  GetModelosCTe(payload) {
    return api.get("/v1/ModelosCTe/" + payload).then((response) => {
      return response.data;
    });
  }

  PostModelosCTe(payload) {
    return api.post("/v1/ModelosCTe/", payload).then((response) => {
      return response.data;
    });
  }

  PutModelosCTe(payload) {
    return api.put("/v1/ModelosCTe/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteModelosCTe(payload) {
    return api.delete("/v1/ModelosCTe/" + payload).then((response) => {
      return response.data;
    });
  }

  GetModelosCTeOData(payload) {
    return api.get("/OData/ModelosCTe" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new ModelosCTeService();
